import api from '@/api'
import endpoints from '@/api/endpoints'

const state = {
}

const getters = {}

const mutations = {}

const actions = {
    deleteOrder({dispatch}, id) {
        return api('DELETE', endpoints.orders.single(id)).then(() => {
            return dispatch('globalAlertAction', {
                type: 'info',
                title: `Order-${id} deleted.`,
            })
        })
    },
    cancelOrder({dispatch}, id) {
        return api('POST', endpoints.orders.cancellation(id)).then(() => {
            return dispatch('globalAlertAction', {
                type: 'info',
                title: `Order-${id}: start cancellation.`,
                message: 'We can\'t guarantee cancellation order in this status!'
            })
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js